module.exports = __webpack_public_path__ + "img/leaderboard.16c564a6.png";